import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainLayoutComponent } from './components/shared/main-layout/main-layout.component';
import { ToasterContainerComponent } from './components/shared/toaster/toaster-container-component';
import { ExportProgressBarComponent } from './components/shared/export-progress-bar/export-progress-bar.component';
import { ToasterComponent } from './components/shared/toaster/toaster.component';
import { ApiService } from './components/shared/api.service';
import { InterceptorService } from './components/shared/interceptor.service';
import { MainService } from './components/shared/main.service';
import { SharedService } from './components/shared/shared.service';
import { ToasterService } from './components/shared/toaster/toaster.service';
import { SharedModule } from './components/shared/shared.module';
import { PagesModule } from './components/pages/pages.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { ChatSupportService } from './components/shared/chat-support.service';
import { SocketsService } from './components/shared/socket/socket.service';
import { SupportChatModule } from './components/pages/support-chat/support-chat.module';
import { NavsearchComponent } from './components/shared/main-layout/navsearch/navsearch.component';
import { SearchComponent } from './components/shared/main-layout/search/search.component';
import { CustomErrorHandlerService } from './components/shared/custom-error-handler.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    NavsearchComponent,
    SearchComponent,
    ToasterContainerComponent,
    ToasterComponent,
    ExportProgressBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    PagesModule,
    SharedModule.forRoot(),
    SupportChatModule,
    NgxMaskDirective,
  ],
  providers: [
    { provide: ErrorHandler, useClass: CustomErrorHandlerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    SharedService,
    MainService,
    ApiService,
    ToasterService,
    SocketsService,
    // ChatSupportService,
    provideAnimationsAsync(),
    provideNgxMask()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
